export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CASE_STUDY_URL = `${BASE_URL}/case-studies`;
export const ARTICLE_URL = `${BASE_URL}/articles`;
export const TESTIMONIALS_URL = `${BASE_URL}/testimonials`;
export const LEADERSHIPS_URL = `${BASE_URL}/the-leadership-teams`;
export const CLIENTS_URL = `${BASE_URL}/clients`;
export const STATISTICS_URL = `${BASE_URL}/unicornly-in-numbers`;
export const MAIL_SERVICE_URL = `${BASE_URL}/mail-services`;
